import { useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import axios from 'axios';

export default function BookInspection() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    car_make: '',
    car_model: '',
    inspection_date: '',
    other_info: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/inspections`, formData);
      alert('Inspection booked successfully!');
      setFormData({ name: '', phone: '', email: '', car_make: '', car_model: '', inspection_date: '', other_info: '' });
    } catch (err) {
      alert('Error booking inspection');
    }
  };

  return (
    <div className="bg-gray-50 text-gray-900 min-h-screen selection:bg-red-600 selection:text-white antialiased overflow-x-hidden">
      <Navbar />
      
      {/* Content wrapper switched from h-screen to a dynamic vertical flex layout */}
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* Left Column: Descriptive Text & Framed Artwork Block */}
          <div className="lg:col-span-5 space-y-6">
            <div className="flex items-center space-x-3">
              <div className="h-8 w-1.5 bg-red-600 rounded"></div>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-blue-950 font-sans tracking-tight">
                BOOK AN INSPECTION
              </h2>
            </div>
            <p className="text-gray-600 leading-relaxed font-light text-base sm:text-lg">
              Have you found a car from our collection that you love? Schedule a private, physical inspection today. Our technical team will coordinate the details and accompany you to verify every detail of your future vehicle.
            </p>
            <div className="hidden lg:block rounded-2xl overflow-hidden shadow-lg border border-gray-100">
              <img
                src="/img/sajies_car2.jpg"
                alt="Physical vehicle inspection service showcase"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>

          {/* Right Column: High-End Contact Submission Form */}
          <div className="lg:col-span-7 bg-white p-8 rounded-2xl border border-gray-200/60 shadow-md">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="Enter your name"
                    required
                    className="w-full p-3 text-black rounded-lg border border-gray-200/80 focus:ring-1 focus:ring-blue-900 focus:border-blue-900 outline-none transition text-sm bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder="e.g. +234"
                    required
                    className="w-full p-3 text-black rounded-lg border border-gray-200/80 focus:ring-1 focus:ring-blue-900 focus:border-blue-900 outline-none transition text-sm bg-gray-50"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="e.g. name@example.com"
                  required
                  className="w-full p-3 text-black rounded-lg border border-gray-200/80 focus:ring-1 focus:ring-blue-900 focus:border-blue-900 outline-none transition text-sm bg-gray-50"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Car Make</label>
                  <input
                    type="text"
                    name="car_make"
                    value={formData.car_make}
                    onChange={(e) => setFormData({ ...formData, car_make: e.target.value })}
                    placeholder="e.g. Toyota"
                    required
                    className="w-full p-3 text-black rounded-lg border border-gray-200/80 focus:ring-1 focus:ring-blue-900 focus:border-blue-900 outline-none transition text-sm bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Car Model</label>
                  <input
                    type="text"
                    name="car_model"
                    value={formData.car_model}
                    onChange={(e) => setFormData({ ...formData, car_model: e.target.value })}
                    placeholder="e.g. Camry"
                    required
                    className="w-full p-3 text-black rounded-lg border border-gray-200/80 focus:ring-1 focus:ring-blue-900 focus:border-blue-900 outline-none transition text-sm bg-gray-50"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Inspection Date</label>
                <input
                  type="date"
                  name="inspection_date"
                  value={formData.inspection_date}
                  onChange={(e) => setFormData({ ...formData, inspection_date: e.target.value })}
                  required
                  className="w-full p-3 text-black rounded-lg border border-gray-200/80 focus:ring-1 focus:ring-blue-900 focus:border-blue-900 outline-none transition text-sm bg-gray-50"
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Other Information (Optional)</label>
                <textarea
                  name="other_info"
                  value={formData.other_info}
                  onChange={(e) => setFormData({ ...formData, other_info: e.target.value })}
                  placeholder="Tell us any specifics you would like checked"
                  rows="3"
                  className="w-full p-3 text-black rounded-lg border border-gray-200/80 focus:ring-1 focus:ring-blue-900 focus:border-blue-900 outline-none transition text-sm bg-gray-50"
                />
              </div>

              <button 
                type="submit" 
                className="w-full bg-red-600 hover:bg-red-700 text-white font-bold p-3.5 rounded-lg shadow-sm hover:shadow-md hover:scale-[1.01] transition duration-200 font-sans tracking-wider"
              >
                SUBMIT BOOKING
              </button>
            </form>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
}
